import React, { useRef, useState, useCallback, useEffect } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { useConfig } from '../ConfigProvider'
import cloneDeep from 'lodash/cloneDeep'
import FileItem from './FileItem'
import Button from '../Buttons'
import CloseButton from '../CloseButton'
import Notification from '../Notification'
import toast from '../toast'
import { uploadFile} from '../../../api/azurestorage'

const filesToArray = (files) => Object.keys(files).map((key) => files[key])

const UploadCustomer = React.forwardRef(( props, ref) => {

	const  {
		accept,
		beforeUpload,
		disabled,
		draggable,
		fileList,
		multiple,
		onChange, 
		onFileRemove,
		stepnum,
		showList,
		tip,
		uploadLimit,
		children, 
		className,
		setFilesList,
		FileListOrigin,
		field,
		form,
		...rest 
	} = props

	const fileInputField = useRef(null)
	const [ files, setFiles ] = useState(fileList)
	const [ dragOver, setDragOver ] = useState(false)

	const { themeColor, primaryColorLevel } = useConfig()

	useEffect(() => {
		setFiles(fileList)
	}, [fileList])

	const triggerMessage = msg => {
		toast.push(<Notification type="danger" duration={2000}>{msg || 'Upload Failed!'}</Notification>, {
			placement: 'top-center'
		})
	}

	const pushFile = (newFiles, file) => {
		for (let f of newFiles) {
			file.push(f)
		}
		return file
	}

	const addNewFiles = async (newFiles) => {
		console.log("agregnaod nueva")
		let file = cloneDeep(files)
		if (typeof uploadLimit === 'number' && uploadLimit !== 0) {
			console.log("entrando aqui")
			if (Object.keys(file).length >= uploadLimit) {

				if(uploadLimit === 1) {
					file.shift()
					file = pushFile(newFiles, file)
				}

				return filesToArray({ ...file })
			}
		}
		console.log("no entre me fui al fondo aqui")
		console.log(file)
		file = pushFile(newFiles, file)
		return filesToArray({ ...file })

	}

	const onNewFileUpload = async(e) => {
		const { files: newFiles } =  e.target
		let result = true
		if(beforeUpload) {
			result = beforeUpload(newFiles, files)

			if(result === false) {
				triggerMessage()
				return
			}
	
			if(typeof result === 'string' && result.length > 0) {
				triggerMessage(result)
				return
			}
		}

		if(result) {
			console.log("entrando")
			const latestUpload = newFiles.length - 1
			const filetoupload = newFiles[latestUpload];
			const responseUpload = await uploadFile(newFiles[latestUpload])
			console.log(responseUpload)
			if(responseUpload!=""){
				//let updatedFiles =await addNewFiles(newFiles)

				const newfile={
					name: filetoupload.name,
					url: responseUpload,
					size: filetoupload.size,
					stepnum:stepnum,
					type:"2"
				}

				//let arraylist = [];
				//arraylist.push(newfile)
				setFilesList([...FileListOrigin, newfile])
				//setFiles(files)
				//onChange?.(files)
			
			}	else{
				alert("No se pudo subir el archivo, favor intentarlo nuevamente")
			}		
		}
	}

	const removeFile = fileIndex => {
		const deletedFileList = FileListOrigin.filter((_, index) => index !== fileIndex)
		setFilesList(deletedFileList)
		//onFileRemove?.(deletedFileList)
	}
	
	const triggerUpload = e => {
		if(!disabled) {
			fileInputField.current?.click()
		}
		e.stopPropagation()
	}

	const renderChildren = () => {
		if(!draggable && !children) {
			return <Button disabled={disabled} onClick={e => e.preventDefault()}>Upload</Button>
		}

		if(draggable && !children) {
			return <span>Choose a file or drag and drop here</span>
		}

		return children
	}

	const handleDragLeave = useCallback(() => {
		if (draggable) {
			setDragOver(false)
		}
	}, [draggable])

	const handleDragOver = useCallback(() => {
		if (draggable && !disabled) {
			setDragOver(true)
		}
	}, [draggable, disabled])
	
	const handleDrop = useCallback(() => {
		if (draggable) {
			setDragOver(false)
		}
	}, [draggable])
	
	const draggableProp = {
		onDragLeave:handleDragLeave,
		onDragOver: handleDragOver,
		onDrop: handleDrop
	}

	const draggableEventFeedbackClass = `border-${themeColor}-${primaryColorLevel}`

	const uploadClass = classNames(
		'upload',
		draggable && `upload-draggable`,
		(draggable && !disabled) && `hover:${draggableEventFeedbackClass}`,
		(draggable && disabled) && 'disabled',
		dragOver && draggableEventFeedbackClass,
		className,
	)

	const uploadInputClass = classNames(
		'upload-input',
		draggable && `draggable`
	)

	return (
		<>
			<div 
				ref={ref} 
				className={uploadClass} 
				{...(draggable ? draggableProp : {onClick: triggerUpload})} 
				{...rest}
			>
				<input
					className={uploadInputClass}
					type="file"
					ref={fileInputField}
					onChange={onNewFileUpload}
					disabled={disabled}
					multiple={multiple}
					accept={accept}
					title=""
					value=""
					{...field}
					{...rest}
				></input>
				{ renderChildren() }
			</div>
			{tip}
			
				<div className="upload-file-list">
					{FileListOrigin.map((file, index) => (
						<FileItem file={file} key={file.name + index}>
							<CloseButton onClick={() => removeFile(index)} className="upload-file-remove" />
						</FileItem>
					))}
				</div>
				
		</>
	)
})

UploadCustomer.propTypes = {
	uploadLimit: PropTypes.number,
	draggable: PropTypes.bool,
	disabled: PropTypes.bool,
	showList: PropTypes.bool,
	multiple: PropTypes.bool,
	accept: PropTypes.string,
	tip: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node
	]),
}

UploadCustomer.defaultProps = {
	draggable: false,
	showList: true,
	disabled: false,
	fileList: []
}

export default UploadCustomer
